import React, { useState, useEffect } from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import { ArrowRight, Calendar } from 'lucide-react';
// import DatePicker from "react-datepicker";
import DatePicker from "../../Shared/common/components/Shared_FormControls/CustomisedReactDatePicker/CustomisedReactDatePicker";
import TextBox from "../../Shared/common/components/Shared_FormControls/TextBox/TextBox";
import "react-datepicker/dist/react-datepicker.css";
import NumberFormat from 'react-number-format';
import Phone from "../../Shared/common/components/Shared_FormControls/PhoneNumberField/PhoneNumberField";
import CustomRadioButton from '../../Shared/common/components/Shared_FormControls/CustomRadioButton/CustomRadioButton';

const DealershipInfoS2 = (props) => {

    const [validated, setValidated] = useState(false);
    const [phoneValid, setPhoneValid] = useState(true);
    const [endDateValid, setEndDateValid] = useState(true);

    useEffect(() => {

        if (props.formData.buildingOwned === true) {
            props.resetLeaseData();
        }

    }, [props.formData.buildingOwned])

    useEffect(() => {

        if (props.formData.buildingOwned === false) {
            if (validated && props.formData.leaseContactPhoneNumber && props.formData.leaseContactPhoneNumber.length === 10)
                setPhoneValid(true);
            else if (validated)
                setPhoneValid(false);
        }

    }, [props.formData.buildingOwned, props.formData.leaseContactPhoneNumber]);

    useEffect(() => {

        if (props.formData.buildingOwned === false) {
            if (validated && props.formData.leaseEndDate)
                setEndDateValid(true);
            else if (validated)
                setEndDateValid(false);
        }

    }, [props.formData.buildingOwned, props.formData.leaseEndDate]);

    const submit = (event) => {

        event.preventDefault();
        event.stopPropagation();
        setValidated(true);

        const form = event.currentTarget;

        let isCustomFieldsValid = true;

        if (props.formData.buildingOwned === false) {

            if (props.formData.leaseContactPhoneNumber && props.formData.leaseContactPhoneNumber.length === 10)
                setPhoneValid(true);
            else {
                setPhoneValid(false);
                isCustomFieldsValid = false;
            }

            if (props.formData.leaseEndDate)
                setEndDateValid(true);
            else {
                setEndDateValid(false);
                isCustomFieldsValid = false;
            }

        }

        if (form.checkValidity() !== false && isCustomFieldsValid) {

            props.submitForm(event);

        }

    }

    return (
        <React.Fragment>
            <Form noValidate
                validated={validated}
                onSubmit={(event) => submit(event)}
                className="text-left from-wrapper marginLeft-6px">
                <div className='onboarding-form-box-modal'>
                    <h1 className="mb-4">Dealership Info</h1>
                    <p className='secondary-text-color mb-4'>Step 2/3 : Lease Details</p>
                    <Form.Group controlId="formBasicFN" className='mb-3'>
                        <b className='d-block mb-2'>Is the dealership location owned or in the process of being purchased?</b>
                        <span className='d-flex align-items-center'>
                            {/* <Form.Check
                            checked={props.formData.buildingOwned === true}
                            onChange={() => props.twoWayBind('buildingOwned', true)}
                            className="inline-block mr-4" type="radio"
                            aria-label="radio 1"
                            label="Yes"
                            name="buildingOwned" /> */}
                            <span className='mr-3'>
                                <CustomRadioButton
                                    label={'Yes'}
                                    objectKey='buildingOwned'
                                    checked={props.formData.buildingOwned === true}
                                    onChange={(key, checked, value) => props.twoWayBind(key, true)} />
                            </span>
                            {/* <Form.Check
                            checked={props.formData.buildingOwned === false}
                            onChange={() => props.twoWayBind('buildingOwned', false)}
                            className="inline-block"
                            type="radio"
                            aria-label="radio 2"
                            label="No"
                            name="buildingOwned" /> */}
                            <CustomRadioButton
                                label={'No'}
                                objectKey='buildingOwned'
                                checked={props.formData.buildingOwned === false}
                                onChange={(key, checked, value) => props.twoWayBind(key, false)} />
                        </span>
                    </Form.Group>
                    {props.formData.buildingOwned === false ?
                        <React.Fragment>
                            <Form.Row className='mx-0 two-fields-row'>
                                <Form.Group as={Col} controlId="formBasicFN">
                                    <TextBox
                                        required
                                        label="Leasing Company"
                                        name="Leasing Company"
                                        value={props.formData.leasingCompany}
                                        objectKey="leasingCompany"
                                        placeholder="Leasing Company"
                                        onChange={(key, value) => props.twoWayBind(key, value)}
                                    />
                                    {/* <Form.Label className="label-color">Leasing Company</Form.Label>
                <Form.Control
                    required
                    type="text"
                    name="leasingCompany"
                    placeholder="Leasing Company"
                    value={props.formData.leasingCompany}
                    className="content-text-13px"
                    onChange={(event) => props.twoWayBind('leasingCompany', event.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                    Please enter valid Leasing Company.
                </Form.Control.Feedback> */}
                                </Form.Group>
                                <Form.Group as={Col} controlId="formBasicLN">
                                    <TextBox
                                        required
                                        label="Leasing Contact Name"
                                        name="Leasing Contact Name"
                                        value={props.formData.leaseContactName}
                                        objectKey="leaseContactName"
                                        placeholder="Leasing Contact Name"
                                        onChange={(key, value) => props.twoWayBind(key, value)}
                                    />
                                    {/* <Form.Label className="label-color">Leasing Contact Name</Form.Label>
                <Form.Control
                    required
                    type="text"
                    name="leaseContactName"
                    value={props.formData.leaseContactName}
                    className="content-text-13px"
                    placeholder="Leasing Contact Name"
                    onChange={(event) => props.twoWayBind('leaseContactName', event.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                    Please enter valid Leasing Contact Name.
                </Form.Control.Feedback> */}
                                </Form.Group>
                                <Form.Group as={Col} controlId="formBasicLN">
                                    <DatePicker
                                        required
                                        validated={validated}
                                        label="Lease End Date"
                                        name="Lease End Date"
                                        selected={props.formData.leaseEndDate}
                                        objectKey="leaseEndDate"
                                        placeholder="MM/DD/YYYY"
                                        dateFormat="MM-dd-y"
                                        value={props.formData.leaseEndDate ? new Date(props.formData.leaseEndDate) : null}
                                        onChange={(key, value) => props.twoWayBind(key, value)}
                                    />
                                    {/* <Form.Label className="content-text-13px label-color leaseEndDateLabel">Lease End Date</Form.Label>
                <div className='custom-datepicker-full-width'>
                    <DatePicker
                        name="leaseEndDate"
                        popperPlacement="auto-right"
                        selected={props.formData.leaseEndDate}
                        dateFormat="MM-dd-y"
                        onChange={(date) => props.twoWayBind('leaseEndDate', date)}
                        placeholderText="mm-dd-yyyy"
                        className={!endDateValid ? 'datepicker-error' : ''}
                        popperProps={{
                            positionFixed: true
                        }}
                    />
                    <Calendar className="calender-lucide-icon" size={16} />
                </div>
                {!endDateValid ? <span style={{ fontSize: '80%', color: '#dc3545' }}>Please enter valid Leasing End Date.</span> : null} */}
                                </Form.Group>
                                <Form.Group as={Col} controlId="formBasicFN">
                                    <Phone
                                        required
                                        validated={validated}
                                        label="Leasing Contact Phone Number"
                                        name="Leasing Contact Phone Number"
                                        objectKey="leaseContactPhoneNumber"
                                        placeholder="(000) 000-0000"
                                        value={props.formData.leaseContactPhoneNumber}
                                        onChange={(key, value) => props.twoWayBind(key, value)}
                                    />
                                    {/* <Form.Label className="content-text-13px label-color">Leasing Contact Phone Number</Form.Label>
                <NumberFormat
                    className='content-text-13px form-control'
                    name="leaseContactPhoneNumber"
                    format='(###) ###-####'
                    placeholder="(000) 000-0000"
                    value={props.formData.leaseContactPhoneNumber}
                    onValueChange={(values) => props.twoWayBind('leaseContactPhoneNumber', values.value)}
                    style={{ borderColor: (!phoneValid ? '#dc3545' : null) }}
                /> */}
                                    {/* <Form.Control
            required
            type="number"
            name="phone"
            placeholder="First Name"
            value={props.formData.firstName}
            className="content-text-13px"
            onChange={(event) => props.twoWayBind('firstName', event.target.value)}
        /> 
                <Form.Control.Feedback type="invalid">
                    Please enter valid Leasing Contact Phone Number.
                </Form.Control.Feedback> */}
                                    {/* {!phoneValid ? <span style={{ fontSize: '80%', color: '#dc3545' }}>Please enter valid Leasing Contact Phone Number.</span> : null} */}
                                </Form.Group>
                            </Form.Row>
                        </React.Fragment> : null
                    }
                </div>
                <div>
                    <Button type="button" onClick={(event) => props.submitForm(event, true)} variant="outline-secondary" className="default-btn">Previous</Button>
                    <Button className="default-btn ml-3" type="submit" variant="primary">Next</Button>
                </div>
            </Form>
        </React.Fragment>
    );

}

export default DealershipInfoS2;